import { CubeIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { Chip } from "./status.tsx";

/** A campaign reference with its type icon (design system §0.8). */
export function CampaignChip({ children }: { children: ReactNode }) {
  return <Chip icon={<CubeIcon size={12} aria-hidden />}>{children}</Chip>;
}
